
export enum EEdgeExpressECIType {
    "Moto" = 1,
    "Recurring" = 2
}

export enum EOpenEdgeResponseCode {
    "Approval" = "000",
    "ZeroDollarAuthApproval" = "032",
    "ImproperFieldData" = 811,
    "TransactionDoesNotExist" = 814,
    "TransactionAlreadyVoided" = 815,
    "TokenLookup" = "005"
}

export enum EPaymentModes {
    "Cash" = 1,
    "Check" = 2,
    "CreditCard" = 3,
    "DirectDebitEFT" = 4,
    "HostedPage" = 5,
    "ACH" = 6,
    "Gift_Card" = 7,
    "ManualAuthorization" = 8,
    "CardOnfile" = 9,
    "ACHOnFile" = 10,
    "ACHManualAuthorization" = 11,
    "DirectDebitEFTOnFile" = 12
}

export enum EPaymentTransactionType {
    "Processed" = 357,
    "Declined" = 358,
    "Reversal_Refund" = 359
}

export enum ECreditCards {
    "American_Express" = "1",
    "Visa" = "2",
    "Master_Card" = "3",
    "Discover" = "4",
    "Diners" = "5",
    "JCB" = "6"
}

export enum EEdgeExpressResultCode {
    "Success" = 0,
    "Canceled" = 3,
    "Fail" = 4,
    "NoDeviceConfigured" = 5,
    "DeviceNotConfigured" = 6,
    "DeviceInitError" = 7,
    "Declined" = 12,
    "Error_Reading_Chip" = 15
}

export enum EOpenEdgeSessionStates {
    "NotFound" = 0,
    "Initializing" = 1,
    "Processing" = 2,
    "Finalizing" = 3,
    "Canceling" = 4,
    "Completed" = 5,
    "PromptingForCard" = 6,
    "PromptingForCardRemoval" = 7,
    "ChipErrorPromptingForCardRemoval" = 8

}

export enum MaintainanceFunctionID {
    "ProductCategory" = 5,
    "Product" = 6,
    "RevenueCategory" = 7,
    "OtherCharges" = 8,
    "VendorTypes" = 9,
    "EmailTemplates" = 10,
}

export enum EUserSecurityFunctionID {
    "User" = 1,
    "RentalSettings" = 2,
    "Product" = 6,
    "POSSettings" = 4,
    "LayoutParts" = 10,
    "POSTerminal" = 11,
    "OpeningCashDrawer" = 12,
    "Layout" = 13,
    "PrinterSettings" = 14,
    "OtherCharges" = 16,
    "CreditDebitCard" = 17,
    "MarketInformation" = 19,
    "CheckSetUp" = 29,
    "Vendor" = 30,
    "DepositSlip" = 36,
    "ConsignmentInventory" = 38,
    "GiftCertificates" = 39,
    "DayEndProcess" = 41,
    "CheckLayout" = 43,
    "CheckPrinting" = 52,
    "VendorACH" = 63,
    "BoothType" = 8,
    "VendorsPayout" = 65,
    "EmailSettings" = 66,
    "NewInventory" = 67,
    "StockDetails" = 68,
    "Email Templates" = 18,
    "ProductCategory" = 5,
    "RevenueCategory" = 7,
    "SalesPerson" = 9,
    "VendorSettings" = 3,
    "VendorAdjustments" = 40,
    "SoldItemSearch" = 42,
    "WISettings" = 75,
    "AutoPayACHVendor" = 76,
    "VendorEmail" = 37,
    "InventorySearch" = 93,
    "ImportInventory" = 95,
    "BarcodeTemplates" = 96,
    "BoothMaintenance" = 100
}

export enum DiscountType {
    "FixedAmount" = "Fixed Amount",
    "Percentage" = "Percentage"
}

export enum PaymentMode {
    "Cash" = 1,
    "Check" = 2,
    "Credit Card" = 3,
    "Direct Debit Payment" = 4
}

export enum ERentalReports {
    "OutstandingBalances" = 52,
    "BoothPriceListing" = 62,
    "AvailableBooths" = 76,
    "DealerBooths" = 77,
    "FinancialAudit" = 81,
    "DealerSecDepositLeaseExpiry" = 82,
    "VendorWithAutoDeductRent" = 83,
    "VendorLeaseExpiry" = 84,
    "DesignVendorReport" = 91,
    "BoothsDroppedbyDealer" = 92,
    "TransactionJournal" = 136,
    "YTDPayments" = 151,
    "VendorListing" = 164,
    "RentalRevenueandPayment" = 169
}

export enum EManagementReports {
    "DealerIDChangeAudit" = 114,
    "NoSaleReport" = 115,
    "VendorManagementSummary" = 53,
    "CombinedModeofPayment" = 117,
    "SalesReceipts" = 124,
    "ManagementSummaryReport" = 128,
    "CheckSummary" = 141,
    "WebInquiryAudit" = 118,
    "WebInquiryEnabledVendorList" = 152,
    "WebInquiryVendorListing" = 153,
    "ManagementReports" = 157,
    "SalesComparisonCountDollar" = 158,
    "SalesComparisonStatement" = 159
}

export enum EPosReports {
    "VendorAdjustments" = 127,
    "PendingSaleReport" = 129,
    "ScrappedPendingSaleReport" = 130,
    "VendorPerformanceReport" = 131,
    "SalesPersonPerformance" = 132,
    "VendorSalesSummary" = 133,
    "CustomerListing" = 134,
    "DayEndReport" = 135,
    "VendorPayoutReport" = 138,
    "TaxExemptionReport" = 140,
    "CustomerCCProcessingCharges" = 142,
    "DailySalesListing" = 144,
    "OutofOrdinaryTransactionsVoidandReturns" = 145,
    "MonthtoDateSalesReport" = 146,
    "SalesConsignmentReports" = 148,
    "SalesByProduct" = 149,
    "VendorDiscountPlansPos" = 155,
    "SalesTaxExemptionReport" = 150,
    "OutstandingLayaway" = 154,
    "SalesbyCreditDebitCardPayment" = 167,
    "ModeofPayment" = 168,
    "VendorCommissionReport" = 173,
}

export enum EInventoryReports {
    "StockReport" = 160,
    "SoldandReturnedItems" = 161,
    "CurrentStockReport" = 162,
    "ReOrderReport" = 163
}

export enum EToaster {
    'TitleInfo' = 'Info',
    'TitleSuccess' = 'Success',
    'MsgSuccessSave' = 'Successfully Saved ',
    'MsgSuccessDelete' = 'Successfully Deleted ',
    'MsgSuccessCreate' = 'Successfully Created ',
    'MsgSuccessVerify' = 'Successfully Verified ',
    'MsgSuccessSent' = 'Successfully Sent ',
    'TitleError' = 'Error',
    'MsgErrorFetch' = 'Error Fetching ',
    'MsgErrorSave' = 'Error Saving ',
    'MsgErrorCreate' = 'Error Creating ',
    'MsgErrorVerify' = 'Error verifying ',
    'MsgErrorSend' = 'Error Sending ',
    'MsgErrorValidate' = 'Error Validating ',
    'MsgErrorDelete' = 'Error Deleting ',
    'MsgInfoNoRightToEdit' = 'You do not have rights to edit ',
    'MsgInfoNoRightToDelete' = 'You do not have rights to delete '
}

export enum EActionTypes {
    "CREATE" = 1,
    "EDIT" = 2,
    "VIEW" = 3,
    "DELETE" = 4
}

export enum ELovTypes {
    'Booth Shape' = 1,
    'Font Name' = 2,
    'Font Style' = 3,
    'Email Service' = 4,
    'Authentication' = 5,
    'Payment Gateway' = 6,
    'Booth Term' = 7,
    'Vendor Term' = 8,
    'Market Term' = 9,
    'Operation Reports' = 10,
    'POS Reports' = 11,
    'Management Reports' = 12,
    'Vendor Name Case Format' = 13,
    'File Type' = 14,
    'Denominations' = 16
}

export enum EDenominationsListOfValues {
    "Pennies" = 'Pennies',
    "Nickels" = 'Nickels',
    "Dimes" = 'Dimes',
    "Quarter" = 'Quarter',
    "Half Dollars" = 'Half Dollars',
    "Dollar Coins" = 'Dollar Coins',
    "$1 Bills" = '$1 Bills',
    "$2 Bills" = '$2 Bills',
    "$5 Bills" = '$5 Bills',
    "$10 Bills" = '$10 Bills',
    "$20 Bills" = '$20 Bills',
    "$50 Bills" = '$50 Bills',
    "$100 Bills" = '$100 Bills'
}

export enum EDenominations {
    "Pennies" = 0.01,
    "Nickels" = 0.05,
    "Dimes" = 0.1,
    "Quarter" = 0.25,
    "Half Dollars" = 0.5,
    "Dollar Coins" = 1,
    "$1 Bills" = 1,
    "$2 Bills" = 2,
    "$5 Bills" = 5,
    "$10 Bills" = 10,
    "$20 Bills" = 20,
    "$50 Bills" = 50,
    "$100 Bills" = 100
}

export enum ECheckPrintPositionDefaults {
    "X1" = '60',
    "Y1" = '100',
    "X2" = '60',
    "Y2" = '480',
    'X3' = '60',
    'Y3' = '900'
}

export enum EPrintOrientation {
    "1PerPage" = 1,
    "2PerPage" = 2,
    "3PerPage" = 3
}

export enum EPrintPart {
    "Top" = 1,
    "Middle" = 2,
    "Bottom" = 3
}

export enum ECountrycode {
    "US" = 1,
    "CA" = 2
}

export enum RentalReceiptIDs {
    "DailyReceipt" = 85,
    "DailyContract" = 86,
    "WeeklyReceipt" = 87,
    "WeeklyContract" = 88,
    "MonthlyReceipt" = 89,
    "MonthlyContract" = 90,
}
export enum EFontName {
    "Arial" = 13
}

export enum ECheckLayout {
    'DiagramHeight' = 400,
    'ThirdDiagramHeightOffset' = 800,
    'Bold' = 'Bold',
    'Italic' = 'Italic',
    'CheckDefaultFontSize' = 12,
    'EJSDiagramWidth' = 1100,
    'EJSDiagramHeight' = 400
}

export enum EBaseTemplateID {
    "ForgotOrResetPassword" = 1,
    "RentalReceipt" = 2,
    "RentalContract" = 3,
    "PaymentReceipt" = 4
}

export enum EPaymentGateway {
    "OpenEdgeExpress" = 43,
    "Stripe" = 172
}

export enum EACHCheckResultCode {
    "Alias_Success" = '005',
    "Check_Submitted" = '011',
    "CheckApproval" = '012',
    "CheckDecline" = '013',
    "CheckWarning" = '014',
    "CheckError" = '015',
    "LimitExceeded" = '016',
    "Daily_Amount_Limit_Exceeded" = '017',
    "Monthly_Amount_Limit_Exceeded" = '018',
    "AlreadyVoided" = 815
}

export enum ESaleType {
    "Retail" = 1,
    "Wholesale" = 2,
    "Online" = 3,
    "ShippedWholesale" = 4,
    "Layaway" = 5,
    "Pending" = 6,
    "Return" = 7,
    "Void" = 8
}
